
import Navbar from './Navbar';
import AlertBox from './AlertBox';
import Form from './Form';
import  React  from "react";

const DeleteAccount= () =>{
    return (
      <div>
        <Navbar />
        <AlertBox />
        <Form />
      </div>
    );
  }

  export default DeleteAccount;
